import type { Coach } from '../../api/client'
import { COACH_EXAMPLE } from '../../billing/rungs'
import { actionWorth } from '../../plan/wording'

// CoachPreview is the Coach on the locked Goals screen (owner, 2026-10-24):
// a faded "Your coach" card in the shape of the real one, under the same
// lock as the Dream Week. Her own reading when the Coach has one (a goal and
// a live diary, so a lapsed Pro sees her real month); until then one worked
// example, marked as such.
export function CoachPreview({ coach }: { coach: Coach | null }) {
  const real = !!coach && coach.has_goal && coach.started && !!coach.progress && coach.summary !== ''
  const summary = real ? coach.summary : COACH_EXAMPLE.summary
  const actions = real && coach.actions.length > 0
    ? coach.actions.slice(0, 3).map((a) => ({ title: a.title, worth: actionWorth(a) }))
    : COACH_EXAMPLE.actions
  return (
    <section className="goals-card coach-preview">
      <div className="coach-preview__head">
        <span className="goal-label">Your coach</span>
        {!real && <span className="coach-preview__example">Example</span>}
      </div>
      <p className="coach-summary">{summary}</p>
      <ul className="coach-actions">
        {actions.map((a) => (
          <li key={a.title}>
            <span className="coach-action__title">{a.title}</span>
            {a.worth && <span className="coach-action__worth">{a.worth}</span>}
          </li>
        ))}
      </ul>
    </section>
  )
}
